import { defineMessages } from 'react-intl';

export default defineMessages({
    sprinklerHelpText: {
        id: 'quoteandbind.ProtectiveDevice.Automatic Sprinkler System: In all areas including attic, bathroom, closet and attached structure. Automatic Sprinkler System Limited Areas: In all areas except attic, bathroom, closet and attached structure areas that are protected by a fire detector.',
        defaultMessage: 'Automatic Sprinkler System: In all areas including attic, bathroom, closet and attached structure.\nAutomatic Sprinkler System Limited Areas: In all areas except attic, bathroom, closet and attached structure areas that are protected by a fire detector.'
    }
});
